import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../../services";
import AppContext from "../../appContext";

const initMoodboards = [];

export default function usePublicMoodboards() {
  const {
    app: {
      pauseQueries,
      project: { id: projectId },
      sessionId
    },
  } = useContext(AppContext);
  const {
    data: publicMoodboards,
    refetch: refetchPublicMoodboards,
    isFetching: isPublicMoodboardsLoading,
  } = useQuery(
    ["publicMoodboards", projectId, sessionId],
    () =>
      api
        .getPublicMoodboards({ projectId, sessionId })
        .then((data) => data?.list ?? initMoodboards),
    {
      placeholderData: () => initMoodboards,
      enabled: !pauseQueries,
    }
  );

  return {
    publicMoodboards,
    isPublicMoodboardsLoading,
    refetchPublicMoodboards,
  };
}
